import { render, staticRenderFns } from "./GroupsTree.vue?vue&type=template&id=439e9d9e&scoped=true&"
import script from "./GroupsTree.vue?vue&type=script&lang=js&"
export * from "./GroupsTree.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTree.vue?vue&type=style&index=0&id=439e9d9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439e9d9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
